// extracted by mini-css-extract-plugin
export default {"container":"icon-text-btn_container__vp2OU","iconWrap":"icon-text-btn_iconWrap__OF0R6","textWrap":"icon-text-btn_textWrap__2XVMv","deleteBtn":"icon-text-btn_deleteBtn__ghx-f"};